<template>
  <main>
    <md-app>
      <md-app-toolbar>
        <Bar />
      </md-app-toolbar>

      <md-app-drawer md-permanent="full">
        <Menu />
      </md-app-drawer>

      <md-app-content>
        <div class="breadcrumbs">
          <router-link to="/admin">Home</router-link> / Projetos rejeitados
        </div>
        <Grid :rejected="true" />
      </md-app-content>
    </md-app>
  </main>
</template>

<script>
import Bar from '../../../components/admin/Bar';
import Menu from '../../../components/admin/Menu';
import Grid from '../../../components/admin/project/Grid';

export default {
  name: "AdminProjectsRejected",
  components: {
    Menu,
    Bar,
    Grid,
  }
};
</script>
